export const isTrue = (value) => value === true;
export const isNotTrue = (value) => value !== true;
export const isPropertyTrue = (property) => (value) => value[property] === true;
export const isPropertyNotTrue = (property) => (value) => value[property] !== true;
export const arePropertiesTrue = (...properties) => (value) => properties.every((property) => value[property] === true);
export const arePropertiesNotTrue = (...properties) => (value) => properties.every((property) => value[property] !== true);
